package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.http.HttpMethod
import com.varabyte.kobweb.compose.http.fetch
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.asList
import org.w3c.dom.get
import org.w3c.dom.set
import org.w3c.dom.svg.SVGElement

@Composable
fun SvgLoader(svg: String, modifier: Modifier = Modifier, color: Color? = null) {
    val scope = rememberCoroutineScope()
    Div(
        attrs = modifier
            .alignContent(AlignContent.Center)
            .toAttrs()
    ) {
        Image(src = svg, modifier = Modifier.fillMaxSize())
        DisposableEffect(this) {
            scope.launch {
                val svgResponse = localStorage[svg] ?: window.fetch(HttpMethod.GET, svg).decodeToString().also {
                    localStorage[svg] = it
                }
                scopeElement.apply {
                    innerHTML = svgResponse
                    (firstElementChild as? SVGElement)?.apply {
                        setAttribute("width", "100%")
                        setAttribute("height", "100%")
                        setAttribute("display", "block")
//                        color?.let {
//                            (firstElementChild as? SVGPathElement)?.setAttribute(
//                                "fill",
//                                it.toString()
//                            )
//                        }
                    }
                    color?.let {
                        getElementsByTagName("path").asList().forEach {
                            it.setAttribute("fill", color.toString())
                        }
                    }
                }
            }
            onDispose {

            }
        }
    }
}